import { GridCellProps } from '@progress/kendo-react-grid'
import React from 'react'

interface Source {
  category: string
  identifier: string
  name: string
  sub_category: string
}

interface CategoriesCellProps extends GridCellProps {
  dataItem: Source
}

export class CategoriesCell extends React.Component<CategoriesCellProps> {
  public render() {
    const categories = this.props.dataItem[this.props.field]
    const categoriesArray = categories ? categories.split('|') : []
    return (
      <td>
        <div className="categories-container">
          {categoriesArray.map((category, i) => <div key={i} className="category">{category}</div>)}
        </div>
      </td>
    )
  }
}
